export const ENCODING = ['scrypt', 'xsalsa20-poly1305'];
export const ENCODING_NONE = ['none'];
export const ENCODING_VERSION = '3';
export const NONCE_LENGTH = 24;
export const SCRYPT_LENGTH = 32 + (3 * 4);
